const GeoAnalysis = [
  {
    path: '/geospatial/sale-analysis',
    name: 'geo_spatial_analysis',
    component: () => import(/* webpackChunkName: "spatial" */'./views/GeospatialAnalysis.vue'),
    meta: {
      requiresAuth: true,
      title: 'GeoSpatial Analysis',
      breadCrumbs: [
        {
          name: 'GeoSpatial Analysis',
          path: '#',
        },
      ],
    },
    children: [],
  },
];

export default GeoAnalysis;
